import Vue from 'vue';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import Vuex from 'vuex';

// import Cookies from 'js-cookie';

import 'normalize.css/normalize.css'; // a modern alternative to CSS resets

import Element from 'element-ui';
import './styles/element-variables.scss';

import '@/styles/index.scss'; // global css

import '../node_modules/grapesjs/dist/css/grapes.min.css'; // grapesjs css

import App from './App.vue';
import store from './store';
import router from './router';

import apolloProvider from './apollo';
import i18n from './i18n'; // internationalization
import './icons'; // icon
import './permission'; // permission control
import * as filters from './filters'; // global filters

import { DefaultApolloClient, provideApolloClient } from '@vue/apollo-composable';

// AG Grid Enterprise license configuration
import '@/utils/ag-grid-enterprise';

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// import { mockXHR } from '../mock';
// if (process.env.NODE_ENV === 'production') {
// 	mockXHR();
// }

// Enable logging
import Logging from '@/logging';
Logging.init();

// size: Cookies.get('size') || 'medium' // set element-ui default size,
Vue.use(Element, {
	i18n: (key, value) => i18n.t(key, value)
});

// register global utility filters
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]);
});
Vue.config.productionTip = false;

import InvoiceTable from '@/components/_Invoice/InvoiceTable.vue';
import pdf from 'vue-pdf';
import ActionDetailDialog from '@/views/_dialogs/ActionDetailDialog.vue';
import EmailDetailDialog from '@/views/_dialogs/EmailDetailDialog.vue';
import ActionDetail from '@/views/_dialogs/ActionDetail.vue';
import LoadingButton from '@/components/_Buttons/LoadingButton.vue';

Vue.component('ActionDetailDialog', ActionDetailDialog);
Vue.component('EmailDetailDialog', EmailDetailDialog);
Vue.component('ActionDetail', ActionDetail);
Vue.component('InvoiceTable', InvoiceTable);
Vue.component('Pdf', pdf);
Vue.component('LoadingButton', LoadingButton);

import TranslationHelper from '@/plugins/translation-helper';
import Formatter from '@/plugins/formatter';
import cognito from '@/cognito';
import getUserInfo from '@/cognito/getUserInfo';
import { loadAndStorePermissions, loadAndStoreUserAndParticipants } from '@/helpers/permission-helper';

import apolloClient from '@/apollo/client';

Vue.use(TranslationHelper);
Vue.use(Formatter);

async function initializeVue() {
	new Vue({
		el: '#app',
		setup() {
			// @ts-ignore
			provideApolloClient(apolloProvider.defaultClient);
		},
		router,
		i18n,
		apolloProvider,
		store,
		render: h => h(App)
	});
}

async function initialize() {
	try {
		const authenticating = sessionStorage.getItem('rslt_authenticating');

		if (!authenticating) {
			await cognito.checkAuthentication();

			await loadPermissions();
			await loadUserAndParticipants();

			initializeVue();
		} else {
			// The user is authenticating, load the app to be able to redirect
			// to the login page. The permissions will be reloaded after successful login.
			initializeVue();
		}
	} catch (e) {
		sessionStorage.removeItem('rslt_authenticating');
		cognito.logout();
	}
}

initialize();

async function loadPermissions() {
	const { data } = await getUserInfo();

	await loadAndStorePermissions(apolloClient, data.sub, store);

	return true;
}

async function loadUserAndParticipants() {
	const { data } = await getUserInfo();

	await loadAndStoreUserAndParticipants(apolloClient, data.sub, store);

	return true;
}
